import React from "react"


export default function Docs() {
  return(
    <>
    <h2>More Info About What You're Reading in This App</h2>
    <h4><strong>The Expense Budget</strong></h4> The Expense Budget funds current city government services, including
    the salaries of government employees, pensions, debt service, and routine
    operating expenses such as copier paper, pens and pencils, printing services, rent
    and utilities, and contracts (see Contract Budget below). It is a legally binding
    commitment to a level of appropriations for a particular fiscal year. It is the Expense
    Budget that people generally think of as “the city budget.” <br/>

    <h4><strong>The Capital Budget</strong></h4> This is a separate budget covering one fiscal year,
    funding physical infrastructure used either in support of government operations
    (such as government offices, schools, and fire stations) or for general public use
    (such as roads, bridges, libraries, and parks). Almost all state and local
    governments in the United States maintain a capital budget or plan distinct from
    their Expense Budget. To be included in the Capital Budget, individual projects must
    have a value of at least $50,000 and for most projects, a period of probable
    usefulness of at least five years.<br/>

    <h4><strong>Who manages the budget?</strong></h4>

    <h6><strong>The Mayor:</strong></h6>
        ● empowers city agencies, under the direction of the Mayor’s Office of Management
        and Budget, to assess spending and revenue needs, and develop budget estimates
        for the upcoming fiscal year; <br/>
        ● issues the Preliminary and Executive Budgets and accompanying Financial Plans;<br/>
        ● negotiates with the City Council;<br/>
        ● implements the adopted Expense, Revenue and Capital Budgets; and<br/>
        ● proposes budget modifications over the course of each fiscal year.<br/><br/>

    <h6><strong>The City Council:</strong></h6>
        ● receives the Mayor’s Preliminary and Executive Budgets;<br/>
        ● reviews and responds to the proposed budgets and holds hearings;<br/>
        ● negotiates among Council Members and with the Mayor;<br/>
        ● adopts the Expense, Revenue, and Capital Budgets;<br/>
        ● accepts or rejects budget modifications proposed during the fiscal year<br/><br/>

      All of this information can be found in the New York City's Budget Guide PDF.
      <a href="https://www.ibo.nyc.ny.us/iboreports/understandingthebudget.pdf" target="_blank" alt="NYC's Budget Guide"> Click here to view it.</a>
    </>
  )
}
